import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const setInitialState = state => ({
  type: types.SET_INITIAL_STATE,
  state,
});

export const setDimensionsFromDimensionList = persistedDimensions => ({
  type: types.SET_DIMENSIONS_FROM_DIMENSION_LIST,
  persistedDimensions,
});

export const setDimensions = dimensions => ({
  type: types.SET_DIMENSIONS,
  dimensions,
});

export const setMetrics = metrics => ({
  type: types.SET_METRICS,
  metrics,
});

export const setDimensionSortByMetric = dimensionSortByMetric => ({
  type: types.SET_DIMENSION_SORT_BY_METRIC,
  dimensionSortByMetric,
});

export const setMetricUnit = metricUnit => ({
  type: types.SET_METRIC_UNIT,
  metricUnit,
});

export const changeDimensionSort = (current, target) => ({
  type: types.CHANGE_DIMENSION_SORT,
  current,
  target,
});

export const changeDimension = (current, target) => ({
  type: types.CHANGE_DIMENSION,
  current,
  target,
});

export const refreshDimension = target => ({
  type: types.REFRESH_DIMENSION,
  target,
});

export const setAllQueries = queries => ({
  type: types.SET_ALL_QUERIES,
  queries,
});

export const initQuery = dimensionName => ({
  type: types.INIT_QUERY,
  dimensionName,
});

export const setQuery = (dimensionName, query) => ({
  type: types.SET_QUERY,
  dimensionName,
  query,
});

export const fetchingDimensionData = dimensionName => ({
  type: types.FETCHING_DIMENSION_DATA,
  dimensionName,
});

export const fetchingDimensionDataSuccess = (dimensionName, response) => ({
  type: types.FETCHING_DIMENSION_DATA_SUCCESS,
  dimensionName,
  response,
});

export const fetchingDimensionDataFail = (dimensionName, errorCode, errorMsg) => ({
  type: types.FETCHING_DIMENSION_DATA_FAIL,
  dimensionName,
  errorCode,
  errorMsg,
});

export const fetchingDimensionDataAbort = dimensionName => ({
  type: types.FETCHING_DIMENSION_DATA_ABORT,
  dimensionName,
});

export const isOrderByTriggerAction = isOrderByTriggered => ({
  type: types.ORDER_BY_TRIGGER_ACTION,
  isOrderByTriggered,
});

export const refreshTable = () => ({
  type: types.REFRESH_TABLE,
});

export const setDimensionTableHeaderInterval = (interval) => ({
  type: types.SET_DIMENSION_TABLE_HEADER,
  interval
});
